export let backendUrl = "https://investment.zippyout.com/api"
// export let backendUrl = "http://localhost:3002/api"
const host = window.location.host
if (host == "localhost:3000") {
    backendUrl = "http://localhost:3002/api"
    // backendUrl = "/api" // for directly hit to production

} else {
    backendUrl = "/api"
}